export default "__VITE_ASSET__DcAubACp__"